export default __webpack_public_path__ + "static/media/wa.7a7fecb1.png";